<template>
  <div v-if="messageList && messageList.length && isVisible">
    <!--达到要求弹出div-->
    <el-card class="box-card" shadow="always">
      <div class="card-header-wrapper">
        <div class="card-header">
          <span class="header-title">您有新的订单，请注意查看</span>
          <i class="el-icon-close close-btn" @click="closeCard"></i>
        </div>
        <div class="header-divider"></div>
      </div>
      <div class="message-content">
        <div v-for="message in messageList" :key="message.orderNo" class="order-item">
          <div class="order-text">订单号<span class="order-no">[{{message.orderNo}}]</span> <span class="order-address">[{{message.address}}]</span></div>
          <el-button 
            class="receive-btn" 
            type="text" 
            @click="confirmReceiveMessage(message.orderNo)">收到</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<!--最新订单消息弹窗-->
<script>
  import {resentOrderMessage, confirmReceiveOrderMessage} from "../../api/modules/app/messageApi.js"

  export default {
    name: "OrderMessage",
    data() {
      return {
        messageList: [],
        timer: null,
        isVisible: true
      }
    },
    mounted() {
      this.getMessage();
    },
    beforeDestroy() {
      // 销毁组件前清理定时器，防止内存泄漏和多个定时器累积
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    methods: {
      closeCard() {
        this.isVisible = false;
      },
      // 语音提醒来了新订单
      voiceTips(address) {
        let txt = '您有新的订单，' + address + '，请注意查看'
        const audio = new Audio('https://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=12&tex=' + encodeURIComponent(txt));
        audio.play().catch(e => {
          // 捕获播放失败（例如：浏览器策略拦截、URL资源失效等），防止控制台报错
          console.warn("订单提示音播放失败:", e);
        });
      },
      getMessage() {
        let that = this;
        // 先调用一次，避免等待15秒才第一次加载
        this.getRecentMessage();
        this.timer = setInterval(() => {
          that.getRecentMessage();
        }, 15000);
      },
      getRecentMessage() {
        resentOrderMessage().then(result => {
          // 优化：只有当数据长度或内容真正发生变化时才更新列表，减少闪烁
          if (JSON.stringify(result.data) !== JSON.stringify(this.messageList)) {
            if (result.data.length > this.messageList.length) {
              this.voiceTips(result.data[result.data.length - 1].address);
              this.isVisible = true; // 有新订单时重新显示
            }
            this.messageList = result.data;
          }
        }).catch(result => {
          console.log(result.data)
        })
      },
      // 确认收到消息
      confirmReceiveMessage(orderNo) {
        let that = this;
        confirmReceiveOrderMessage(orderNo).then(result => {
          that.$notify.success({
            message: result.data,
            duration: 2000
          });
          that.getRecentMessage();
        }).catch(result => {
          console.log(result.data)
        })
      }
    }
  }
</script>

<style scoped>
  .box-card {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 480px;
    z-index: 2000;
    border-radius: 12px;
    border: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  }

  /* 移除Element UI默认的header样式 */
  ::v-deep .el-card__header {
    display: none;
  }

  /* 自定义header容器 */
  .card-header-wrapper {
    margin: 8px 0;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
  }

  /* 自定义分割线 - 与标题文字左右对齐 */
  .header-divider {
    width: 100%;
    height: 1px;
    background-color: #f0f0f0;
  }

  .header-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1;
  }

  .close-btn {
    cursor: pointer;
    font-size: 18px;
    color: #909399;
    transition: color 0.2s;
  }

  .close-btn:hover {
    color: #333;
  }

  ::v-deep .el-card__body {
    padding: 12px 20px;
    max-height: 200px;
    overflow-y: auto;
  }

  .order-item {
    padding: 8px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #fafafa;
  }

  .order-item:last-child {
    border-bottom: none;
  }

  .order-text {
    font-size: 14px;
    color: #606266;
    line-height: 1;
    flex: 1;
    text-align: left;
  }

  .order-no {
    color: #909399;
    margin: 0 4px;
  }

  .order-address {
    color: #606266;
  }

  .receive-btn {
    padding: 0;
    color: #12A76F;
    font-weight: 500;
    font-size: 14px;
    margin-left: 12px;
  }

  .receive-btn:hover {
    opacity: 0.8;
    color: #12A76F;
  }

  /* 自定义滚动条 */
  ::v-deep .el-card__body::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-card__body::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/app/OrderMessage.vue